import ClearIcon from '@mui/icons-material/Clear';
import {
  Alert,
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';

import React from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import AddressInputWithAutocomplete from '../../common/adress-input-with-autocomplete/address-input-with-autocomplete';
import { CustomerType } from '../../../interfaces/common/customer';
import { ILocation } from '../../../interfaces/common/location';
import { emptyLocation } from '../../../data/locations';
import { emptyRegion, regions, RegionType } from '../../../data/regions';
import { isMobile, isTablet } from 'react-device-detect';
import AreaInput from '../../common/city-input/city-input';
import Grid2 from '@mui/material/Unstable_Grid2';
import LebanonMap, { LocationType } from '../../common/lebanon-map/lebanon-map';

export interface CreateLocationFormProps {
  defaultLocationId?: string;
  customer: CustomerType;
  successCallback?: (location: ILocation) => void;
}

function CreateLocationForm({
  defaultLocationId,
  customer,
  successCallback,
}: CreateLocationFormProps) {
  const [locationData, setLocationData] = useState<ILocation | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();


  const { user, config } = useContext(AuthContext);

  React.useEffect(() => {
    console.log('use effect');
    const getAndSetLocation = async () => {
      if (defaultLocationId !== undefined) {
        setIsLoading(true);
        try {
          const endpoint = `${API_ENDPOINT}/api/v1/location/${defaultLocationId}/`;
          console.log(endpoint);
          const response = await axios.get<ILocation>(endpoint, config);
          console.log(response);
          setResponse(response);
          setLocationData(response.data);
        } catch (e) {
          setLocationData(undefined);
          if (axios.isAxiosError(e)) {
            setMessage('Failed to load customer location data: ' + e.message);
          } else {
            setMessage('Failed to load customer location data');
          }
          console.log(e);
        }
        setIsLoading(false);
      } else {
        setLocationData(emptyLocation);
      }
    };
    getAndSetLocation();
  }, [defaultLocationId]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (locationData) {
      setIsLoading(true);
      setResponse(undefined);
      setLoadingMessage('Saving customer location...');
      const requestData = {
        ...locationData,
        customer: customer.id,
      };

      try {
        let response;
        if (defaultLocationId !== undefined) {
          // update existing
          response = await axios.put(
            `${API_ENDPOINT}/api/v1/location/${defaultLocationId}/`,
            requestData,
            config
          );
          successCallback && successCallback(locationData);
        } else {
          // create new
          response = await axios.post(
            `${API_ENDPOINT}/api/v1/locations/`,
            requestData,
            config
          );
          successCallback && successCallback(response.data);
        }
        setResponse(response);
        if (response.status >= 200 && response.status < 300) {
          setMessage('customer location saved successfully');
        }
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage(
            'Failed to save customer location: ' + e.response?.statusText
          );
        } else {
          setMessage('Failed to save customer location');
        }
        console.log(e);
      }
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 3, mb: 3 }}
      >
        {locationData?.id === '' ? 'Create Location' : 'Edit Location'}
      </Typography>

      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <LinearProgress />
        </>
      ) : (
        <>
          {message !== '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>
          )}

          {locationData && (
            <>
              <br />
              <form onSubmit={handleSubmit}>
               
              <Grid2 container spacing={2}>
                <Grid2 xs={12} md={8}>

                   <FormControl fullWidth>
                    <TextField
                      autoComplete="off"
                      disabled
                      value={customer?.name ?? 'No Name'}
                      label={'Customer'}
                      required
                    />
                  </FormControl>
                  <br />
                  <br />

                  <AreaInput
                  area={locationData.area ?? null}
                  setArea={(c) =>
                    setLocationData({ ...locationData, area: c ?? undefined})
                  }
                />
                <br />
                <br />
                <FormControl fullWidth>
                  <TextField
                    autoComplete="off"
                    multiline
                    minRows={4}
                    value={locationData.directions}
                    label={'Directions'}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        directions: e.target.value,
                      })
                    }
                  />
                </FormControl>
                </Grid2>
                    <Grid2 xs={12} md={4}>
                        <LebanonMap locations={[{
                          area: locationData.area,
                          id: locationData.area?.code ?? '',
                          label: locationData.area?.name_en ?? '',
                          type: LocationType.GENERIC
                        }]} 
                        showPartitions={false}
                        width={200}
                        height={250}  
                        scale={3500}
                        />
                </Grid2>
               
                </Grid2>
                <br />
                <br />
                <Button
                  size={(isMobile && !isTablet) ? 'small' : 'medium'}
                  variant="contained"
                  type={'submit'}
                >
                  Save
                </Button>
              </form>
            </>
          )}
        </>
      )}
    </>
  );
}
export default CreateLocationForm;
